<template>
  <div class="tableMain" ref="tableMain" id="field" :style="{
    'width': '100%',
    'height': '100%',
    'display': 'flex',
    'align-items': 'center',
    'justify-content': 'space-between',
    'border': (properties['selected'] ? 'solid 1px black' : (properties['border'] ? 'solid 1px gray' : (print ? '' : 'solid 1px gray'))),
    'position': 'relative'}"
    
    @mouseup="fieldMouseUp('', $event)"
    @mouseleave="fieldMouseUp('', $event)"
    @mousemove="fieldMouseMove('', $event)">

      <div class="tableColumn" :id="'table' + data['id'] + 'col' + i" v-for="(col, i) in (properties['columns'] ? properties['columns'] : [])" :key="'col' + i" :style="{
        'pointer-events': 'none',
        'user-select': 'none',
        'width': (col['width'] + '%'),
        'height': '100%',
        'border-right': (((i + 1) != properties['numCol']) ? (properties['selected'] ? 'solid 1px black' : (properties['border'] ? 'solid 1px gray' : (print ? '' : 'solid 1px gray'))) : ''),
        'position': 'relative',}">

        <!-- Column Resizer HTML -->
        <div class="tableColumnResize" v-if="((i + 1) != properties['numCol']) && properties['selected']" :style="{
          'pointer-events': (tableData['tableResizeMouseDown'] ? 'none': ''),}"
          @mousedown="tableColResizeMouseDown(properties['columns'][i], properties['columns'][i + 1], $event)"></div>
        
        <div class="tableRow" :id="'table' + data['id'] + 'row' + i + ',' + i2" v-for="(row, i2) in (col['rows'] ? col['rows'] : [])" :key="'row' + i2" :style="{
          'pointer-events': 'none',
          'user-select': (tableData['tableResizeMouseDown'] ? 'none': ''),
          'width': '100%',
          'height': (row['height'] + '%'),
          'border-bottom': (((i2 + 1) != properties['numRow']) ? (properties['selected'] ? 'solid 1px black' : (properties['border'] ? 'solid 1px gray' : (print ? '' : 'solid 1px gray'))) : ''),
          'position': 'relative',}">

          <!-- Row Resizer HTML -->
          <div class="tableRowResize" v-if="((i2 + 1) != properties['numRow']) && properties['selected']" :style="{
            'pointer-events': (tableData['tableResizeMouseDown'] ? 'none': ''),}"
            @mousedown="tableRowResizeMouseDown(properties['columns'][i]['rows'][i2], properties['columns'][i]['rows'][i2 + 1], $event)"></div>

          <!-- Index HTML -->
          <div class="tableRowIndex" v-if="(i <= 0) && properties['selected'] && !print">
            {{row['valueIndex']}}
          </div>
 
          <div class="textDisplay" :ref="'textDisplay' + i + ',' + i2" v-html="formattedText(row['value'], row['valueIndex'])" :style="{
            'width': '100%',
            'height': 'auto',
            'line-height': (((Math.floor(((row['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 2) + 'px'),
            'font-size': ((Math.floor(((row['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 'px'),
            'font-family': row['fontFamily'],
            'font-weight': row['fontWeight'],
            'text-align': row['fontJustify'],
            'position': 'absolute',
            'top': '0px',
            'bottom': '0px',
            'background-color': (tableData['cellSel'] ? (tableData['cellSel']['id'] == (i + ',' + i2) ? '#fffa' : '') : ''),
            'pointer-events': 'none',
            'user-select': (tableData['tableResizeMouseDown'] ? 'none': ''),
            'word-wrap': 'break-word',
            'white-space': 'pre-wrap',
            'z-index': '10',
            'overflow-x': (textAreaFocus ? 'hidden' : (row['fontOverflow'] ? 'visible' : 'hidden')),
            'overflow-y': (row['fontOverflow'] ? 'visible' : 'hidden')}"></div>

          <textarea class="textArea" :id="'field ' + 'textArea'" :ref="'textArea' + i + ',' + i2" v-model="row['value']" spellcheck="false" :style="{
            'pointer-events': ((!tableData['tableResizeMouseDown'] && properties['selected']) ? 'all' : 'none'),
            'line-height': (((Math.floor(((row['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 2) + 'px'),
            'font-size': ((Math.floor(((row['fontSize'] * zoomLevel) * fontPtPx) * 10) / 10) + 'px'),
            'font-family': row['fontFamily'],
            'font-weight': row['fontWeight'],
            'text-align': row['fontJustify'],
            'word-wrap': row['fontOverflow'] ? 'break-word' : '',
            'overflow-y': (textAreaFocus ? '' : 'hidden'),
            'user-select': (textAreaFocus ? '' : 'none'),
            'opacity': (textAreaFocus ? '' : '0'),
            'z-index': '10',}"
            
            @keydown="textAreaBtn('keyDown', '', $event)"
            @scroll="textAreaBtn('scroll', '', $event)"
            @input="textAreaBtn('scroll', '', $event)"
            @focus="textAreaBtn('focus', true, $event)"
            @blur="textAreaBtn('focus', false, $event)"
            @mousedown="textAreaBtn('mousedown', row, $event)"></textarea>

        </div>
      </div>

      <!-- Column Editor HTML -->
      <div class="editorColumnMain" v-if="properties['selected'] && !print" :style="{
        'left': (((((data['posX2'] - data['posX1']) * zoomLevel) / 2) - 175) + 'px'),
        'pointer-events': (tableData['tableResizeMouseDown'] ? 'none': 'all'),}">
          <select :style="{'margin': '0 5px 0 0', 'width': '135px'}" v-model="properties['itemKey']" @change="getItemKeys()">
            <option v-for="(k, i) in tableData['itemKeyList']" :key="'keyItem' + i" :value="k">{{k}}</option>
          </select>
          <select ref="keySelect" :style="{'margin': '0 5px 0 0', 'width': '135px'}">
            <option v-for="(k, i) in tableData['itemKeys']" :key="'key' + i" :value="k">{{k}}</option>
          </select>
          <button title="Add Key" @click="editorBtn('addkey', '')" :disabled="!tableData['cellSel']">
            <svg viewBox="0 0 500 500" :style="{'fill': '#ffff'}"><path :d="icon['plus']"/></svg></button>
          <button title="Format All Rows" @click="editorBtn('formatrows', properties['columns'][parseInt(tableData['cellSel']['id'].split('\,')[0])])" :disabled="!tableData['cellSel']">
            <svg viewBox="0 0 500 500" :style="{'fill': '#ffff'}"><path :d="icon['downarrow']"/></svg></button>
      </div>

      <!-- Table Editor HTML -->
      <div class="editorMain" v-if="properties['selected'] && !print">
        <div class="row">
          <div class="column">
            <button :class="[properties['autoGenerate'] ? 'selected' : '']" title="Auto Generate" :style="{'font-size': '16px', 'font-weight': 'bold', 'color': 'white'}"
              @click="editorBtn('autoGenerate', '')">A</button>
            <button :class="[properties['border'] ? 'selected' : '']" title="Border"
              @click="editorBtn('border', '')"><svg viewBox="0 0 500 500"><path :d="icon['border']"/></svg></button>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="label">Ind</div>
            <input type="number" v-model="properties['numInd']" min="0" :style="{'width': '50px'}"
              @input="editorBtn('index', '')"/>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="label">Col</div>
            <input type="number" v-model="properties['numCol']" min="1" :style="{'width': '50px'}"/>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="label">Row</div>
            <input type="number" v-model="properties['numRow']" min="1" :style="{'width': '50px'}"/>
          </div>
        </div>
      </div>

      <!-- Text Editor HTML -->
      <div class="textEditorMain" v-if="tableData['cellSel'] && properties['selected'] && !print" :style="{'left': (((((data['posX2'] - data['posX1']) * zoomLevel) / 2) - 100) + 'px')}">
        <div class="row">
          <div class="column" :style="{'flex': '1'}">
            <select :style="{'width': '100%'}" v-model="tableData['cellSel']['fontFamily']">
              <option v-for="(f, i) in fonts" :key="'font' + i" :value="f">{{f.replace(/\'/g, '')}}</option>
            </select>
            <input type="number" v-model="tableData['cellSel']['fontSize']" min="1" :style="{'width': '50px', 'margin': '0 0 0 5px'}"/>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button :class="[(tableData['cellSel']['fontJustify'] == 'left') ? 'selected' : '']" title="Justify Left"
              @click="editorBtn('justify', 'left')"><svg viewBox="0 0 500 500"><path :d="icon['justifyL']"/></svg></button>
            <button :class="[(tableData['cellSel']['fontJustify'] == 'center') ? 'selected' : '']" title="Justify Center"
              @click="editorBtn('justify', 'center')"><svg viewBox="0 0 500 500"><path :d="icon['justifyC']"/></svg></button>
            <button :class="[(tableData['cellSel']['fontJustify'] == 'right') ? 'selected' : '']" title="Justify Right"
              @click="editorBtn('justify', 'right')"><svg viewBox="0 0 500 500"><path :d="icon['justifyR']"/></svg></button>
          </div>
          <div class="column">
            <button :class="[(tableData['cellSel']['fontWeight'] == 'bold') ? 'selected' : '']" title="Bold" :style="{'font-size': '16px', 'font-weight': 'bold', 'color': 'white'}"
              @click="editorBtn('bold', '')">B</button>
            <button :class="[tableData['cellSel']['fontOverflow'] ? 'selected' : '']" title="Overflow"
              @click="editorBtn('wrap', '')"><svg viewBox="0 0 500 500"><path :d="icon['overflow']"/></svg></button>
          </div>
        </div>
      </div>
      
      <!-- Sub Editor HTMl -->
      <div class="subEditorMain" v-if="properties['selected'] && !print">
        <button title="Auto Width" :style="{'margin': '0 0 5px 0', 'font-size': '16px', 'font-weight': 'bold', 'color': 'white'}"
          @click="editorBtn('autowidth', '')">W</button>
        <button title="Auto Height" :style="{'margin': '0 0 5px 0', 'font-size': '16px', 'font-weight': 'bold', 'color': 'white'}"
          @click="editorBtn('autoheight', '')">H</button>
        <!-- <button title="Copy"
          @click="editorBtn('wrap', '')"><svg viewBox="0 0 500 500"><path :d="icon['copy']"/></svg></button> -->
      </div>
  </div>
</template>

<script>
  /* eslint-disable */
  
  
  export default {
    name: 'designerText',
    components: {
      
    },
    props: {
      data: { type: Object, default: function() { return {}; }},
      printData: { type: Object, default: function() { return {}; }},

      properties: { type: Object, default: function() { return {}; }},
      zoomLevel: { type: Number, default: 1 },
      fontPtPx: { type: Number, default: 1 },
      print: { type: Boolean, default: false },
    },
    data() { 
      return {
        //-- Table Data
        tableData: {
          'col1Sel': null,
          'col2Sel': null,
          'row1Sel': null,
          'row2Sel': null,

          'percentRange': 0,

          'tableResizeMouseDown': false,

          'cellSel': null,

          'itemKeys': [],
          'itemKeyList': [],
        },

        //-- Text Data
        textAreaFocus: false,

        //-- Referenced Default data
        fonts: [
          'Arial, sans-serif',
          'Verdana, sans-serif',
          'Tahoma, sans-serif',
          '\'Trebuchet MS\', sans-serif',
          '\'Times New Roman\', serif',
          'Georgia, serif',
          'Garamond, serif',
          '\'Courier New\', monospace',
          '\'Brush Script MT\', cursive',
        ],
        icon: {
          'minus': 'M100 240L400 240L400 260L100 260L100 240Z',
          'plus': 'M100 240L400 240L400 260L100 260L100 240Z M260 100L260 400L240 400L240 100L260 100Z',
          'downarrow': 'M400 254.41L250 400L100 254.41L195.09 254.41L195.09 100L305.15 100L305.15 254.41L400 254.41Z',
          'uparrow': 'M100 245.59L250 100L400 245.59L304.91 245.59L304.91 400L194.85 400L194.85 245.59L100 245.59Z',

          'alignT': 'M50 195L50 190L450 190L450 195L50 195ZM50 125L50 120L450 120L450 125L50 125ZM50 55L50 50L450 50L450 55L50 55Z',
          'alignC': 'M50 322.5L50 317.5L450 317.5L450 322.5L50 322.5ZM50 252.5L50 247.5L450 247.5L450 252.5L50 252.5ZM50 182.5L50 177.5L450 177.5L450 182.5L50 182.5Z',
          'alignB': 'M50 450L50 445L450 445L450 450L50 450ZM50 380L50 375L450 375L450 380L50 380ZM50 310L50 305L450 305L450 310L50 310Z',
            
          'justifyL': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L230 130L230 150L50 150L50 130Z M50 370L330 370L330 390L50 390L50 370Z',
          'justifyC': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L450 130L450 150L50 150L50 130Z M50 370L450 370L450 390L50 390L50 370Z',
          'justifyR': 'M50 250L450 250L450 270L50 270L50 250Z M270 130L450 130L450 150L270 150L270 130Z M170 370L450 370L450 390L170 390L170 370Z',
      
          'border': 'M240 450L240 440L320 440L320 450L240 450ZM60 60L60 450L50 450L50 50L450 50L450 60L60 60ZM110 450L110 440L190 440L190 450L110 450ZM370 450L370 440L440 440L440 368.1L450 368.1L450 450L370 450ZM440 320L440 240L450 240L450 320L440 320ZM440 190L440 110L450 110L450 190L440 190Z',
          'overflow': 'M405 100L400 100L400 55L55 55L55 400L100 400L100 405L50 405L50 50L405 50L405 100ZM150 355L150 350L450 350L450 355L150 355ZM150 260L150 255L450 255L450 260L150 260ZM150 165L150 160L450 160L450 165L150 165Z',
          'copy': 'M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z M450 392.86L450 50L107.14 50 M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z',
        }
      }
    },
    computed: {
      getFocusState() {
        return this.properties['focus'];
      },
      getSelectedState() {
        return this.properties['selected'];
      },
      getColChange() {
        return this.properties['numCol'];
      },
      getRowChange() {
        return this.properties['numRow'];
      },
    },
    created() {
      this.generateCells();
    },
    mounted() {
      this.$nextTick(() => {
        this.getItemKeyList();
      });
    },
    beforeDestroy() {
      
    },
    methods: {
      getItemKeyList: async function() {
        //-- Get Arrays
        this.$set(this.tableData, 'itemKeyList', []);
        Object.keys(this.printData).forEach((k , i) => {
          if (Array.isArray(this.printData[k])) {
            this.tableData['itemKeyList'].push(k);
          }
        });

        this.getItemKeys();
      },
      getItemKeys: async function() {
        //-- Get keys
        var keys = {};
        if (Array.isArray(this.printData[this.properties['itemKey']])) {
          this.printData[this.properties['itemKey']].forEach((k, i) => {
            Object.keys(k).forEach((k2, i2) => {
              this.$set(keys, k2, '');
            });
          });
          this.$set(this.tableData, 'itemKeys', Object.keys(keys));
        }
      },
      generateCells: async function() {
        this.$set(this.tableData, 'cellSel', null);

        //-- Get current columns
        var existCol = JSON.parse(JSON.stringify(this.properties['columns']));

        //-- Generate cell data from columns, generate new if non-existing
        this.$set(this.properties, 'columns', []);
        for(var i = 0; i < this.properties['numCol']; i++) {
          if (existCol[i]) {
            //console.log('%cExisting Column', 'color: green;', existCol[i]);
          }
          //-- Generate columns
          var colObj = {
            'id': i,
            'width': (100 / this.properties['numCol']),
            'rows': [],
          }

          //-- Generate rows
          for(var i2 = 0; i2 < this.properties['numRow']; i2++) {
            var cellObj = JSON.parse(JSON.stringify(this.properties['cellDefault']));

            //-- Set ID
            this.$set(cellObj, 'id', i + ',' + i2);

            //-- Set default indexing
            this.$set(cellObj, 'valueIndex', parseInt(this.properties['numInd']) + i2);

            //-- Set default height
            this.$set(cellObj, 'height', 100 / this.properties['numRow']);
          
            //-- Check for existing
            if (existCol[i] && existCol[i]['rows'][i2]) {
              this.$set(cellObj, 'fontFamily', existCol[i]['rows'][i2]['fontFamily']);
              this.$set(cellObj, 'fontJustify', existCol[i]['rows'][i2]['fontJustify']);
              this.$set(cellObj, 'fontOverflow', existCol[i]['rows'][i2]['fontOverflow']);
              this.$set(cellObj, 'fontSize', existCol[i]['rows'][i2]['fontSize']);
              this.$set(cellObj, 'fontWeight', existCol[i]['rows'][i2]['fontWeight']);
              this.$set(cellObj, 'value', existCol[i]['rows'][i2]['value']);
            }

            //-- Push cell to row
            colObj['rows'].push(cellObj);
          }

          //-- Push column into array
          this.properties['columns'].push(colObj);
        }

        //console.log(this.properties['columns']);
      },
      formattedText(text, index) {
        if (text) {
          if (this.textAreaFocus) {
            return text ? text : '';
          } else {
            //---- Set variables
            var text = JSON.parse(JSON.stringify(text));
            var match = [];
            var pattern = /{([^}]*)}/g;

            //---- Get keys found in text
            var textKeys = [];
            while (match = pattern.exec(text)) { textKeys.push(match[0]); }

            //-- Format each key into a displayed item
            textKeys.forEach((k, i) => {
              var textFormattedKey = '';
              if (this.print) {
                if (this.printData[this.properties['itemKey']] && this.printData[this.properties['itemKey']][index]) {
                  textFormattedKey = this.printData[this.properties['itemKey']][index][k.replace(/\{|\}/g, '')] ? this.printData[this.properties['itemKey']][index][k.replace(/\{|\}/g, '')] : '';
                  // console.log(textFormattedKey);
                }
              } else {
                textFormattedKey = '<span style="' + 
                'width: auto;' + 
                'height:' + (((Math.floor(((this.properties['fontSize'] * this.zoomLevel) *this. fontPtPx) * 10) / 10) + 2) + 'px;') + 
                'padding: 0 5px;' + 
                'font-size:' + ((Math.floor(((this.properties['fontSize'] * this.zoomLevel) *this. fontPtPx) * 10) / 10) + 'px;') + 
                'display: inline-block;' + 
                'background-color: #0002;' + 
                'border: solid 1px gray;' + 
                'border-radius: 20px;' + 
                '">' + k.replace(/\{|\}/g, '') + '</span>';
              
              }  

              text = text.replace(k, textFormattedKey);
            });

            return text;
          }
        } else { return ''; }
      },
      textAreaBtn: async function(cmd, data, e) {
        switch(cmd) {
          case 'keyDown':
            //-- Set variables
            var textAreaDOM = this.$refs['textArea' + this.tableData['cellSel']['id']][0];
            var textDisplayDOM = this.$refs['textDisplay' + this.tableData['cellSel']['id']][0];

            switch(e['key']) {
              case 'Tab':
                e.preventDefault();

                //-- Get current selection position
                var selStart = textAreaDOM['selectionStart'];
                var selEnd = textAreaDOM['selectionEnd'];

                if (selStart == selEnd) {
                  
                  var newValue = this.tableData['cellSel']['value'].substring(0, selStart) + '    ' + this.tableData['cellSel']['value'].substring(selStart, this.tableData['cellSel']['value']['length']);
                  this.$set(this.tableData['cellSel'], 'value', newValue);

                  this.$nextTick(() => {
                    textAreaDOM['selectionStart'] = selStart + 4;
                    textAreaDOM['selectionEnd'] = selStart + 4;
                  });
                }
                break;
              case 'A':
              case 'a':
                if (e['ctrlKey']) {
                  e.preventDefault(); 

                  textAreaDOM['selectionStart'] = 0;
                  textAreaDOM['selectionEnd'] = this.tableData['cellSel']['value']['length'];
                }
                break;
            }
            break;
          case 'mousedown':
            //console.log(data);
            this.$set(this.tableData, 'cellSel', data);
            break;
          case 'focus':
            if (this.tableData['cellSel']) {
              var textAreaDOM = this.$refs['textArea' + this.tableData['cellSel']['id']][0];
              var textDisplayDOM = this.$refs['textDisplay' + this.tableData['cellSel']['id']][0];
              this.textAreaFocus = data;
              this.$set(this.properties, 'focus', data);
              if (data) {
                textAreaDOM.focus();

                this.$nextTick(() => {
                  //-- Set scroll to edit area
                  textDisplayDOM.scrollTo(textAreaDOM['scrollLeft'], textAreaDOM['scrollTop']);

                  //-- Set cursor to end
                  textAreaDOM['selectionStart'] = this.tableData['cellSel']['value']['length'];
                  textAreaDOM['selectionEnd'] = this.tableData['cellSel']['value']['length'];
                });
              } else {
                textAreaDOM.blur();

                this.$nextTick(() => {
                  //-- Set scroll to top
                  textDisplayDOM.scrollTo(0, 0);
                  
                  //-- Deselect / onfocus when Field is not selected
                  this.$nextTick(() => {
                    if (!this.properties['selected']) {
                      this.$set(this.tableData, 'cellSel', null);
                    }
                  });
                });
              }
            }
            break;
          case 'scroll':
            //-- Set variables
            var textAreaDOM = this.$refs['textArea' + this.tableData['cellSel']['id']][0];
            var textDisplayDOM = this.$refs['textDisplay' + this.tableData['cellSel']['id']][0];

            textDisplayDOM.scrollTo(textAreaDOM['scrollLeft'], textAreaDOM['scrollTop']);
            break;
        }
      },
      tableColResizeMouseDown: async function(col1, col2, e) {
        this.$set(this.tableData, 'tableResizeMouseDown', true)
        this.$set(this.tableData, 'col1Sel', col1);
        this.$set(this.tableData, 'col2Sel', col2);
        this.$set(this.tableData, 'percentRange', (this.tableData['col1Sel']['width'] + this.tableData['col2Sel']['width']));

        //-- Reblur
        if (this.tableData['cellSel']) {
          var textAreaDOM = this.$refs['textArea' + this.tableData['cellSel']['id']][0];
          var textDisplayDOM = this.$refs['textDisplay' + this.tableData['cellSel']['id']][0];

          textAreaDOM.blur();
          //-- Set scroll to top
          this.$nextTick(() => {
            textDisplayDOM.scrollTo(0, 0);
          });
        }

        this.$nextTick(() => {
          this.$set(this.tableData, 'cellSel', null);
        });
      },
      tableRowResizeMouseDown: async function(row1, row2, e) {
        this.$set(this.tableData, 'tableResizeMouseDown', true)
        this.$set(this.tableData, 'row1Sel', row1);
        this.$set(this.tableData, 'row2Sel', row2);
        this.$set(this.tableData, 'percentRange', (this.tableData['row1Sel']['height'] + this.tableData['row2Sel']['height']));

        //-- Reblur
        if (this.tableData['cellSel']) {
          var textAreaDOM = this.$refs['textArea' + this.tableData['cellSel']['id']][0];
          var textDisplayDOM = this.$refs['textDisplay' + this.tableData['cellSel']['id']][0];

          textAreaDOM.blur();
          //-- Set scroll to top
          this.$nextTick(() => {
            textDisplayDOM.scrollTo(0, 0);
          });
        }

        this.$nextTick(() => {
          this.$set(this.tableData, 'cellSel', null);
        });
      },
      fieldMouseUp: async function(cmd, e) {
        this.$set(this.tableData, 'tableResizeMouseDown', false);
        this.$set(this.tableData, 'percentRange', 0);
        this.$set(this.tableData, 'col1Sel', null);
        this.$set(this.tableData, 'col2Sel', null);
        this.$set(this.tableData, 'row1Sel', null);
        this.$set(this.tableData, 'row2Sel', null);
      },
      fieldMouseMove: async function(cmd, e) {
        var tableMainDOM = this.$refs['tableMain'];
        
        if (this.tableData['tableResizeMouseDown'] && this.tableData['col1Sel'] && this.tableData['col2Sel']) {
          var col1DOM = document.getElementById('table' + this.data['id'] + 'col' + this.tableData['col1Sel']['id']);
          var col2DOM = document.getElementById('table' + this.data['id'] + 'col' + this.tableData['col2Sel']['id']);

          //--Positions
          var startPos = col1DOM.getBoundingClientRect()['left'] - tableMainDOM.getBoundingClientRect()['left'];
          var endPos = (col2DOM.getBoundingClientRect()['left'] - tableMainDOM.getBoundingClientRect()['left']) + col2DOM.getBoundingClientRect()['width'];
          
          //-- Set width
          var ratio = ((e['layerX'] - startPos) / (endPos - startPos)) * this.tableData['percentRange'];
          this.$set(this.tableData['col1Sel'], 'width', (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));
          this.$set(this.tableData['col2Sel'], 'width', this.tableData['percentRange'] - (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));

        } else if (this.tableData['tableResizeMouseDown'] && this.tableData['row1Sel'] && this.tableData['row2Sel']) {
          var row1DOM = document.getElementById('table' + this.data['id'] + 'row' + this.tableData['row1Sel']['id']);
          var row2DOM = document.getElementById('table' + this.data['id'] + 'row' + this.tableData['row2Sel']['id']);

          var row1Layer = parseInt(this.tableData['row1Sel']['id'].split('\,')[1]);
          var row2Layer = parseInt(this.tableData['row2Sel']['id'].split('\,')[1]);

          //--Positions
          var startPos = row1DOM.getBoundingClientRect()['top'] - tableMainDOM.getBoundingClientRect()['top'];
          var endPos = (row2DOM.getBoundingClientRect()['top'] - tableMainDOM.getBoundingClientRect()['top']) + row2DOM.getBoundingClientRect()['height'];

          //-- Set height
          var ratio = ((e['layerY'] - startPos) / (endPos - startPos)) * this.tableData['percentRange'];
          this.properties['columns'].forEach((c, i) => {
            // c['rows'][row1Layer]
            this.$set(c['rows'][row1Layer], 'height', (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));
            this.$set(c['rows'][row2Layer], 'height', this.tableData['percentRange'] - (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));
          });
          // this.$set(this.tableData['row1Sel'], 'height', (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));
          // this.$set(this.tableData['row2Sel'], 'height', this.tableData['percentRange'] - (ratio > (this.tableData['percentRange'] - 2) ? (this.tableData['percentRange'] - 2) : (ratio < 2 ? 2 : ratio)));
        }
      },
      editorBtn: async function(cmd, data) {
        switch(cmd) {
          case 'justify':
            this.$set(this.tableData['cellSel'], 'fontJustify', data);
            break;
          case 'bold':
            this.$set(this.tableData['cellSel'], 'fontWeight', ((this.tableData['cellSel']['fontWeight'] == 'normal') ? 'bold' : 'normal'));
            break;
          case 'autoGenerate':
            this.$set(this.properties, 'autoGenerate', this.properties['autoGenerate'] ? false : true);
            break;
          case 'index':
            this.properties['columns'].forEach((c, i) => {
              c['rows'].forEach((r, i2) => {
                this.$set(r, 'valueIndex', parseInt(this.properties['numInd']) + i2);
              });
            });
            break;
          case 'border':
            this.$set(this.properties, 'border', this.properties['border'] ? false : true);
            break;
          case 'wrap':
            this.$set(this.tableData['cellSel'], 'fontOverflow', this.tableData['cellSel']['fontOverflow'] ? false : true);
            break;
          case 'autowidth':
            var newWidth = 100 / this.properties['numCol'];
            this.properties['columns'].forEach((c, i) => {
              this.$set(c, 'width', newWidth);
            });
            break;
          case 'autoheight':
            var newHeight = 100 / this.properties['numRow'];
            this.properties['columns'].forEach((c, i) => {
              c['rows'].forEach((r, i2) => {
                this.$set(r, 'height', newHeight);
              });
            });
            break;
          case 'addkey':
            if (this.tableData['cellSel']) {
              var keySelectDOM = this.$refs['keySelect'];
              this.$set(this.tableData['cellSel'], 'value', this.tableData['cellSel']['value'] + '{' + keySelectDOM['value'] + '}')
            }
            break;
          case 'formatrows':
            var rowObj = JSON.parse(JSON.stringify(this.tableData['cellSel']));
            var rowIndex = this.properties['columns'].indexOf(this.tableData['cellSel']);
            data['rows'].forEach((r, i) => {
              if (i != rowIndex) {
                this.$set(r, 'value', rowObj['value']);
                this.$set(r, 'fontFamily', rowObj['fontFamily']);
                this.$set(r, 'fontSize', rowObj['fontSize']);
                this.$set(r, 'fontWeight', rowObj['fontWeight']);
                this.$set(r, 'fontJustify', rowObj['fontJustify']);
                this.$set(r, 'fontOverflow', rowObj['fontOverflow']);
              }

                // 'value': '',
                // 'fontFamily': 'Arial, sans-serif',
                // 'fontSize': 11,
                // 'fontWeight': 'normal',
                // 'fontJustify': 'left',
                // 'fontOverflow': true,
            });
            break;
        }
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      getFocusState: { deep: true, handler(h) { this.textAreaBtn('focus', h); } },
      getSelectedState: { deep: true, handler(h) { this.textAreaBtn('focus', h); } },
      getColChange: { deep: true, handler(h) { this.generateCells(); } },
      getRowChange: { deep: true, handler(h) { this.generateCells(); } },
      data: { deep: true, handler(h) { this.getItemKeyList(); } },
    },
  };
</script>

<style scoped>
  /* -- Controls CSS -- */
  body button {
    width: 30px;
    height: 30px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #444f;
    border-radius: 0px;
  }
  
  body button:hover {
    background-color: #555f;
  }
  
  body button:focus {
    border: none;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body button svg {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    fill: #0000;
    stroke: #ffff;
    stroke-width: 12px;
    pointer-events: none;
  }

  body button.selected {
    border: solid 1px #aaaf;
  }

  body button.selected svg {
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  body input {
    width: 100%;
    height: 30px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body input:hover {
    border: solid 1px #0004;
  }
  
  body input:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body input:disabled {
    background-color: #dddf;
  }
  
  body select {
    width: 100%;
    height: 30px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body select:hover {
    border: solid 1px #0004;
  }
  
  body select:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  ::-moz-selection { /* Code for Firefox */
    color: #0000;
    background: #888f;
  }

  ::selection {
    color: #0000;
    background: #888f;
  }

  .textArea {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    padding: 0px;
    color: #000;
    -webkit-text-fill-color: transparent;
    background-color: #0000;
    border: none;
    outline: none;
    resize: none; 
    white-space: pre-wrap;
  }

  .textArea:focus {
    border: none;
    outline: none;
  }

  .tableColumnResize {
    width: 9px;
    height: auto;
    min-width: 9px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    right: -5px;
    pointer-events: all;
    cursor: e-resize;
    z-index: 20;
  }
  
  .tableRowResize {
    width: auto;
    height: 9px;
    min-height: 9px;
    position: absolute;
    bottom: -5px;
    left: 0px;
    right: 0px;
    pointer-events: all;
    cursor: n-resize;
    z-index: 20;
  }

  .tableRowIndex {
    width: 30px;
    height: auto;
    font-size: 12px;
    font-weight: bold;
    color: #ffff;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: -45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #444f;
    user-select: none;
    z-index: 20;
  }

  .editorColumnMain {
    width: 350px;
    height: 40px;
    padding: 5px;
    position: absolute;
    bottom: -55px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #444f;
    z-index: 20;
  }

  .editorMain {
    width: 95px;
    height: auto;
    padding: 5px 5px 0 5px;
    position: absolute;
    bottom: 0px;
    right: -108px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }

  .editorMain > .row {
    width: 100%;
    height: 30px;
    margin: 0 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .editorMain > .row > .column {
    width: auto;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .editorMain > .row > .column > .label {
    width: 30px;
    height: 30px;
    margin: 0 5px 0 0;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffff;
  }

  .textEditorMain {
    width: 200px;
    height: 75px;
    padding: 5px;
    position: absolute;
    bottom: -134px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }

  .textEditorMain > .row {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .textEditorMain > .row > .column {
    width: auto;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .subEditorMain {
    width: 40px;
    height: 110px;
    padding: 5px;
    position: absolute;
    bottom: 0px;
    left: -88px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }
</style>